"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceFeatureFlagsSchema = exports.DeviceFeatureFlag = void 0;
const zod_1 = require("zod");
/**
 * Device features that can be enabled or disabled on demand
 */
var DeviceFeatureFlag;
(function (DeviceFeatureFlag) {
    /** If disabled, device won't capture and send screenshots */
    DeviceFeatureFlag["ScreenshotCapture"] = "screenshotCapture";
    /** If disabled, device won't send System Logs to the server */
    DeviceFeatureFlag["SystemLogs"] = "systemLogs";
    /** If disabled, device won't send CPU usage telemetry to the server */
    DeviceFeatureFlag["CpuUsage"] = "cpuUsage";
    /** If disabled, device won't send Memory usage telemetry to the server */
    DeviceFeatureFlag["MemoryUsage"] = "memoryUsage";
    /** If disabled, device won't load any plugins */
    DeviceFeatureFlag["Plugins"] = "plugins";
    /** If disabled, device won't load any runners */
    DeviceFeatureFlag["Runners"] = "runners";
    /** If disabled, device won't load any custom scripts */
    DeviceFeatureFlag["CustomScripts"] = "customScripts";
    /** If disabled, device won't perform screenshot analysis - computing aHash etc. */
    DeviceFeatureFlag["ScreenshotAnalysis"] = "screenshotAnalysis";
})(DeviceFeatureFlag || (exports.DeviceFeatureFlag = DeviceFeatureFlag = {}));
exports.DeviceFeatureFlagsSchema = zod_1.z.record(zod_1.z.nativeEnum(DeviceFeatureFlag), zod_1.z.boolean());
